import { Injectable } from '@angular/core';
import { OpfoelgningDto } from '../api/models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { ServiceaftaleDto } from '../api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceordreDto } from '../api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';

@Injectable({
  providedIn: 'root',
})
export class OpfoelgningerService {
  constructor() {}

  opfoelgningState(opfoelgninger: OpfoelgningDto[], username: string) {
    const useropfoelgninger = opfoelgninger.filter((p) => p.user == username);
    const otheropfoelgninger = opfoelgninger.filter((p) => p.user != username);

    if (useropfoelgninger.length == 1 && otheropfoelgninger.length == 0) return 1;
    if (useropfoelgninger.length > 1 && otheropfoelgninger.length == 0) return 2;
    if (useropfoelgninger.length == 0 && otheropfoelgninger.length > 0) return 3;
    if (useropfoelgninger.length == 1 && otheropfoelgninger.length > 0) return 4;
    if (useropfoelgninger.length > 1 && otheropfoelgninger.length > 0) return 5;
    return 0;
  }

  serviceaftaleState(serviceaftale: ServiceaftaleDto, username: string): number {
    return this.opfoelgningState(serviceaftale.opfoelgningList, username);
  }

  serviceordreState(serviceordre: ServiceordreDto, username: string): number {
    return this.opfoelgningState(serviceordre.opfoelgningList, username);
  }

  otherUsers(opfoelgninger: OpfoelgningDto[], username: string): string {
    const otherUsers = [
      ...new Set(
        opfoelgninger
          .filter((p) => p.user != username)
          .map((o) => o.user)
          .map((item) => item)
      ),
    ].sort((x, y) => (x > y ? 1 : -1));
    return otherUsers.join(',');
  }
}
